const dbg = parseInt(document.documentElement.getAttribute('data-debug'));

class Collapse{
    constructor(){
        this.dbg=false;
    }
    static boot(){
        this.dbg= dbg;
        // console.log("DBG" + this.dbg);
        if(this.dbg>3)console.log('collpase.js load');

        document.querySelectorAll('[data-toggle=collapse]').forEach((e)=>{
            e.classList.add('collapsed');
            if(this.dbg)console.log('collapse on: ' + e.innerHTML);
            e.addEventListener('click',this.listen);
            let n = e.nextElementSibling;

            if(n && n.classList.contains('collapse-icons')){
                // n.addEventListener('click',listenCollapse);
            }
        });
        document.querySelectorAll('.collapse.in').forEach(c=>{
            let div = c.querySelector('*:first-child');
            if(div) c.style['min-height']=div.offsetHeight +'px';
        });
    }

     static collapse(c){
        let collapsed = c.classList.contains('in');
        c.classList.add('collapsing');
        c.classList.remove('collapse','in');
        let height=0;
        if(dbg) console.log('collapse');
  
        if(!collapsed) {
            if(c.hasAttribute('data-toggle')){ //??
                div=document.querySelector(c.getAttribute('data-toggle'));
                height = div.offsetHeight  ;
            }else{
                // let div = c.querySelector('*:first-child');
                let children = c.children;
                if(children.length > 0){
                    for(let i =0; i< children.length; i++){
                        height+=children[i].offsetHeight;
                    }
                }
            }
        }

        c.style['min-height']=height+'px';

        setTimeout(()=>{
            let t = c.parentNode.querySelector('[data-toggler]');
            c.classList.remove('in','collapsing');
            if(collapsed){
                c.classList.add('collapse');
                if(t) t.classList.add('collapsed');
            }else{
                c.classList.add('in','collapse');
                if(t) t.classList.remove('collapsed');
            }
        } ,350);
    }


    static listen(event){
        let self =Collapse;

        let e=event.currentTarget;
        let c =e.parentNode.querySelector('.collapse');
        if(!c) return;
        let style=c.style.display;
        let collapsing = c.classList.contains('collapsing');

        if(collapsing) return ; //prevent event

        self.collapse(c);
        document.querySelectorAll('.collapse.in').forEach((e)=>{
            self.collapse(e);
        });
    }

}

class Dropdown{

     static close(){
        document.querySelectorAll('.dropdown-menu').forEach(function(dd){
            if(dd.style.display=='block') dd.style.display='none';
        });
    }

    static listen(event){

        let self=Dropdown;
        let e=event.currentTarget;
        /** @type {HTMLElement} */
        if(dbg) console.log("dropdown click "+e.parentNode);
        let d =e.parentNode.querySelector('.dropdown-menu');
        if(!d) return;
        if(dbg) console.log('dropdown click');
        let style=d.style.display;

        if(style=='block'){
            d.style.display='none';

        }else {
            self.close(); //close every other dropdown on page
            d.style.display='block';
            let offset = d.getBoundingClientRect().right-window.innerWidth;
            if(offset > 0 ) d.style.left-=offset;
        }
        event.stopPropagation();
    }

    static boot(){
        var self=this;
        if(dbg) console.log("bootstrap: dropdown boot");
        document.querySelectorAll('[data-toggle=dropdown]').forEach((e)=>{
            if(dbg) console.log("click on "+ e);
            e.addEventListener('click',self.listen);
        });

        window.addEventListener('click',(event)=>{
            var self=this;

            let t =event.target;
            if(!t.matches('[data-toggle=collapse]')){
                if(dbg) console.log('dropdown close');
                self.close();
            }
        });
    }

}

export  {Collapse,Dropdown};

function  addFocusToFormGroup(){
    if(dbg) console.log('add focus');
    document.querySelectorAll('.form-group').forEach((g=>{
        g.addEventListener('focus',(event)=>{
            g.classList.add('focus');
        });
        g.addEventListener('focusout',(event)=>{
            g.classList.remove('focus');
        });
    }))
}

function initAllTabs() {
    if(dbg) console.log('bootstrap: init all tabs');
    document.querySelectorAll(".nav-tabs .nav-link").forEach(function (elem) {
        // let container = elem.parentElement.parentElement;

        elem.addEventListener("click", function (event) {
            event.preventDefault();
            this.parentNode.querySelector(".nav-link.active").classList.remove('active');
            this.classList.add("active");
            let tabId='#';
            if(this.hasAttribute('data-bs-target')){
                tabId=this.getAttribute('data-bs-target')
            }else
                tabId = this.getAttribute('href');
            tabId=tabId.replace('#', '');
            let tab = document.getElementById(tabId);

            if(tab){
                tab.parentNode.querySelector(".active").classList.remove('active','show');
                tab.classList.add('active','show');
            }else if(this.dbg) console.log('tab not found '+ tabId);
        });
    });
}

window.addEventListener('DOMContentLoaded',()=>{
    if(dbg) console.log('bootstrap: load');
    Collapse.boot();
    Dropdown.boot();
    initAllTabs();
    addFocusToFormGroup();
    document.querySelectorAll(['click.bs.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]']).forEach((e)=>{
        e.addEventListener('click',(event)=>{
            event.preventDefault();
            //console.log(e);
            let id = e.getAttribute('aria-controls');
            e.closest('[role=tablist]').querySelectorAll('[data-toggle=tab]').forEach(a=>{
                a.classList.remove('active');
            });

            e.classList.add('active');

            if(id){
                let target =document.getElementById(id);
                if(target){
                    target.parentNode.querySelectorAll('[role=tabpanel]').forEach(t=>{
                        t.style.display='none';
                    });

                    let s=target.style.display;
                    target.style.display='block'; //(s=='block')?'none':'block';
                }
            }
            return true;
        });
        // console.log(e);
    })
});

